import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import { getLanesStyleClick, getLanesStyleHover } from "../style/lanes";

export function getLanesInteractions(layer, control) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    // Unlike the per-way lane styles, these need the resolution: the lane bands are
    // laid out in screen pixels, so the select overlay has to scale them the same way
    // the layer's own style function does or the highlight won't line up.
    style: function (feature, resolution) {
      return getLanesStyleClick(feature, resolution);
    },
  });
  clickSelect.on("select", function (e) {
    if (e.target.getFeatures().getLength() > 0) {
      control.set(
        "selectedFeatures",
        Array.from(e.target.getFeatures().getArray()),
      );
    } else {
      control.set("selectedFeatures", undefined);
    }
  });
  const hoverSelect = new Select({
    layers: [layer],
    condition: pointerMove,
    style: function (feature, resolution) {
      return getLanesStyleHover(feature, resolution);
    },
  });

  return [clickSelect, hoverSelect];
}
